import { useContext } from 'react';

import AuthContext from 'app/providers/auth/AuthContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
